import * as React from "react";
import * as Scrivito from "scrivito";
import { FooterLinkedImage } from "components";
import s from "./ImageFooterWidget.module.scss";

Scrivito.provideComponent("ImageFooterWidget", ({ widget }) => (
  <FooterLinkedImage widget={widget} className={s.footerImageWrapper} />
));
